import { requests } from './index'

type getIsValidCodeResponseType = {
  code: string
  message: string
  amount?: string
}
type getIsValidCodeType = (value: string) => Promise<getIsValidCodeResponseType>

type getBlackZipcodesResponseType = {
  zip_codes: string
}
type getBlackZipcodesType = () => Promise<getBlackZipcodesResponseType>

const voucherValidEndpoint = '/de/api/voucher/validate/'
const blacklistZipEndpoint = '/de/api/zipcodes/blacklist'

/**
 * Validates a SENEC.Cloud 3.0 voucher code
 * @param code
 * @param parameters
 * @returns {Promise<Response | boolean>}
 */
export const getIsValidCode: getIsValidCodeType = (value) => {
  const query = `${voucherValidEndpoint}${value || ''}`
  return requests.getApi<getIsValidCodeResponseType>(query)
}

/**
 * Gets black ZIP codes
 * @returns {Promise<Response>|boolean}
 */
export const getBlackZipcodes: getBlackZipcodesType = () => {
  return requests.getApi<getBlackZipcodesResponseType>(blacklistZipEndpoint)
}
